<template>
  <div class="f-center f-column">
    <div class="testimonial-box">
      <div
        style="border-radius: 50%; height: 4.5rem; width: 4.5rem; overflow: hidden"
        class="mr-4 no-shrink f-center"
        :size="avatar_size"
      >
        <img
          style="height: 100%; width: 100%"
          :src="getImage(img)"
        />
      </div>

      <div class="f-column">
        <div class="testimonial_person d-flex f-wrap">
          <div class="pr-3">
            {{ name }}
          </div>
          <div class="testimonial_bio mt-auto">{{ bio }}</div>
        </div>
        <div class="testimonial_text mt-2">
          {{ text }}
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TestimonialBox',
  props: {
    name: String,
    bio: String,
    text: String,
    img: String,
  },
  data() {
    return {
      avatar_size: '3rem',
    }
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/img/${img}`, import.meta.url).href
    },
  },
  computed: {
    mdAndDown() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
  },
}
</script>

<style lang="scss" scoped>
.testimonial-box {
  position: relative;
  display: flex;
  // flex-direction: column;
  padding: 1rem;
  // background: var(--clr-black-1);
  border-radius: 8px;
  max-width: 34rem;
  .testimonial {
    &_icon {
      position: absolute;
      width: 78px;
      transform: scaleX(-1);
      top: 12px;
      left: 22px;
      svg {
        opacity: 0.08;
        fill: var(--clr-white-0);
      }
    }
    &_text {
      color: var(--clr-white-0);
      color: var(--clr-grey-2);
    }
    &_person {
      color: var(--clr-white-0);
      font-weight: 700;
    }
    &_bio {
      color: var(--clr-grey-2);
      font-size: 0.8rem;
      font-weight: 400;
    }
  }
}
</style>
